import actionTypes from './actionTypes'
import { getLibraryObjectName } from 'helpers/store/getLibraryObjectName'
import boardTypes from 'helpers/enums/canny/boardTypes'

const storeActions = {
	filtersFetched(filters) {
		return {
			type: actionTypes.STORE_FILTERS_FETCHED,
			filters,
		}
	},
	standardFetched(standard) {
		return {
			type: actionTypes.STORE_STANDARD_FETCHED,
			standard,
		}
	},
	filterSelected(id, filterType) {
		return {
			type: actionTypes.STORE_FILTER_SELECTED,
			id,
			filterType,
		}
	},
	updateFilters(filters, tab, query) {
		return {
			type: actionTypes.STORE_UPDATE_FILTERS,
			filters,
			tab,
			query,
		}
	},
	tabSelected(tab) {
		return {
			type: actionTypes.STORE_FILTERS_TAB_SELECTED,
			tab,
		}
	},
	clearFiltersSelected() {
		return {
			type: actionTypes.STORE_FILTERS_CLEAR,
		}
	},
	clearStandardFiltersSelected() {
		return {
			type: actionTypes.STORE_STANDARD_FILTERS_CLEAR,
		}
	},
	clearStandardAndQueryFiltersSelected() {
		return {
			type: actionTypes.STORE_STANDARD_AND_QUERY_FILTERS_CLEAR,
		}
	},
	onFiltersSearchSelected() {
		return {
			type: actionTypes.STORE_FILTERS_SEARCH,
		}
	},
	onQuerySearchSelected(query) {
		return {
			type: actionTypes.STORE_QUERY_SEARCH,
			query,
		}
	},
	onClearConfirmedFilters(query) {
		return {
			type: actionTypes.STORE_CLEAR_SELECTED_FILTERS,
			query,
		}
	},
	onQueryInputChange(query) {
		return {
			type: actionTypes.STORE_QUERY_INPUT_CHANGE,
			query,
		}
	},
	onWidgetItemSelected(redirectUrl) {
		return {
			type: actionTypes.STORE_WIDGET_ITEM_SELECTED,
			redirectUrl,
		}
	},
	onStoreNppThumbnailSelected(redirectUrl, event) {
		return {
			type: actionTypes.STORE_NPP_THUMBNAIL_SELECTED,
			redirectUrl,
			event,
		}
	},
	getResultsCatalogSuccess(catalog) {
		return {
			type: actionTypes.STORE_CATALOG_GET_RESULTS_SUCCESS,
			catalog,
		}
	},
	getResultsCatalogError() {
		return {
			type: actionTypes.STORE_CATALOG_GET_RESULTS_ERROR,
		}
	},
	getResultsError() {
		return {
			type: actionTypes.STORE_SEARCH_GET_RESULTS_ERROR,
		}
	},
	getResultsSuccess(entities, page, hasMore) {
		return {
			type: actionTypes.STORE_SEARCH_GET_RESULTS_SUCCESS,
			entities,
			page,
			hasMore,
		}
	},
	getFolderResultsSuccess(folderTitle, entities, page, hasMore) {
		return {
			type: actionTypes.STORE_FOLDER_GET_RESULTS_SUCCESS,
			folderTitle,
			entities,
			page,
			hasMore,
		}
	},
	getStorePreviewPageSuccess(payload) {
		return {
			type: actionTypes.STORE_PREVIEW_FETCHED,
			response: payload,
		}
	},
	getSearchNextPage() {
		return {
			type: actionTypes.STORE_SEARCH_GET_NEXT_PAGE,
		}
	},
	getFolderNextPage() {
		return {
			type: actionTypes.STORE_FOLDER_GET_NEXT_PAGE,
		}
	},
	shareLesson(entity) {
		return {
			type: actionTypes.STORE_SEARCH_SHARE_LESSON,
			entityUID: entity.data.entityUID,
			entityType: getLibraryObjectName(entity.library_object_type),
		}
	},
	addToPrivateLibrary(libraryType, libraryId) {
		return {
			type: actionTypes.STORE_ADD_LESSON_TO_PRIVATE_LIBRARY,
			libraryType,
			libraryId,
		}
	},
	addToPrivateLibrarySuccess(libraryType, libraryId, lesson) {
		return {
			type: actionTypes.STORE_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS,
			libraryType,
			libraryId,
			lesson,
		}
	},
	addToPrivateLibraryFailed(error, library_type) {
		return {
			type: actionTypes.STORE_ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED,
			error,
			library_type,
		}
	},
	lessonTypeFilterSelected(value) {
		return {
			type: actionTypes.STORE_LESSON_TYPE_FILTER_SELECTED,
			value,
		}
	},
	launchVideoPreview(presentation_uid) {
		return {
			type: actionTypes.STORE_LAUNCH_VIDEO_PREVIEW,
			presentation_uid,
		}
	},
	initializeVideoPreview(presentation_uid) {
		return {
			type: actionTypes.STORE_INITIALIZE_VIDEO_PREVIEW,
			presentation_uid,
		}
	},
	launchFrontOfTheClassroomPreview(presentation_uid) {
		return {
			type: actionTypes.STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM,
			presentation_uid,
		}
	},
	launchFrontOfTheClassroomSessionFetched(payload) {
		return {
			type: actionTypes.STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED,
			payload,
		}
	},
	launchFrontOfTheClassroomSessionFailed(serverError) {
		return {
			type: actionTypes.STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED,
			serverError,
		}
	},
	launchAllDevicesPreview(presentation_uid) {
		return {
			type: actionTypes.STORE_PREVIEW_LAUNCH_ALL_DEVICES,
			presentation_uid,
		}
	},
	launchStudentPacedPreview(presentation_uid) {
		return {
			type: actionTypes.STORE_PREVIEW_LAUNCH_STUDENT_PACED,
			presentation_uid,
		}
	},
	editLesson(lessonData) {
		return {
			type: actionTypes.STORE_EDIT_LESSON,
			lessonData,
		}
	},
	searchNoResultsFeedbackSelected(variant) {
		return {
			type: actionTypes.STORE_SEARCH_NO_RESULTS_FEEDBACK_SELECTED,
			boardType: boardTypes.CONTENT_FEEDBACK,
			variant,
		}
	},
}

export default storeActions
